import { Loader } from "@mantine/core"
import { InfoBox } from "@tfg/ui"
import { FC } from "react"
import { useTranslation } from "react-i18next"

import { FindMappingByTypeResponseDto } from "~/gen/api/types"
import { MappingTable } from "~/pages/Admin/Mapping/components/MappingTable"
import { useFindTypeKeysQuery } from "~/pages/Admin/Mapping/hooks/useFindTypeKeysQuery"
import {
  MappingCollapseProps,
  MappingTypeNames,
  Pagination,
} from "~/pages/Admin/Mapping/types"

type Props = MappingCollapseProps & {
  standards: FindMappingByTypeResponseDto["mappings"]
  pagination: Pagination
  search: string
  setSearch: (search: string) => void
}

export const StandardMapping: FC<Props> = ({
  standards,
  pagination,
  search,
  setSearch,
  isOpen,
  close,
  open,
}) => {
  const {
    data: standardsList,
    isPending: isLoading,
    isError,
  } = useFindTypeKeysQuery(MappingTypeNames.STANDARD)
  const { t } = useTranslation()

  if (isLoading) {
    return <Loader />
  }
  if (isError) {
    return (
      <InfoBox
        variant="error"
        title={t("dataLoad.error.title")}
        message={t("dataLoad.error.message")}
      />
    )
  }
  return (
    <>
      <MappingTable
        types={standards}
        typesList={standardsList.data.map((type) => ({
          ...type,
          deletedAt: type.deletedAt ? new Date(type.deletedAt) : null,
        }))}
        typeName={MappingTypeNames.STANDARD}
        pagination={pagination}
        search={search}
        setSearch={setSearch}
        isOpen={isOpen}
        close={close}
        open={open}
      />
    </>
  )
}
